(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volts-product-enriched"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initAccordions(root) {
    root.querySelectorAll('[data-vpe-acc]').forEach(function (acc) {
      var isFaq = acc.dataset.vpeAcc === 'faq';

      acc.querySelectorAll('.vpe-acc__trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item    = trigger.closest('.vpe-acc__item');
          var isOpen  = item.classList.contains('is-open');
          var opening = !isOpen;

          if (isFaq && opening) {
            acc.querySelectorAll('.vpe-acc__item.is-open').forEach(function (el) {
              el.classList.remove('is-open');
              el.querySelector('.vpe-acc__trigger').setAttribute('aria-expanded', 'false');
            });
          }

          item.classList.toggle('is-open', opening);
          trigger.setAttribute('aria-expanded', String(opening));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordions(document);
    });
  } else {
    initAccordions(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
